// extracted by mini-css-extract-plugin
export default {"widgetMobileBreakpoint":"568px","grid":"Grid_grid__2C66e","grid__vertical":"Grid_grid__vertical__wh1I0","col":"Grid_col__LAbt9"};